module.exports = __webpack_public_path__ + "static/media/icon-small-calendar.02762068.svg";